import api from "../../../api";
import {CounterpartyId} from "platformed-client/types";
import {param, typedQuery} from "../../typing";

export const counterparties = typedQuery(["vendorToolkit", "counterparties"], async () => {
  return await api.vendorToolkit.counterparties.list();
});

export const counterparty = typedQuery(
  ["vendorToolkit", "counterparty", param<CounterpartyId>("counterpartyId")],
  async counterpartyId => {
    return await api.vendorToolkit.counterparties.get(counterpartyId);
  },
);
